<form [formGroup]="gForm">
<div class="container" *ngIf="!showSuccessMessage">
  <div class="row mt-3 mb-4" >
    <div class="col-12 header-text">
      Grievances
    </div>
  </div>
  <div class="row">
    <div class="col-12 small-header-text">
      Member Information
    </div>
    <div class="col-lg-6 col-12">
      <label for="firstName" class="label-text">First Name</label>
      <input type="text" class="text-input" name="firstName" id="firstName" formControlName="firstName" required>
      <div *ngIf="gForm.get('firstName')?.dirty && gForm.get('firstName')?.invalid" class="warning" minlength="3">
        First Name is required
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <label for="lastName" class="label-text">Last Name</label>
      <input type="text" class="text-input" name="lastName" id="lastName" formControlName="lastName" required>
      <div *ngIf="gForm.get('lastName')?.dirty && gForm.get('lastName')?.invalid" class="warning">
        Last Name is required
      </div>
    </div>
    <div class="col-12 col-lg-12 mt-3">
      <label for="otherName" class="label-text">If different, name of main subscriber</label>
      <input type="text" class="text-input" name="otherName" id="otherName" formControlName="otherName" >
    </div>
    <div class="col-12 col-lg-12 mt-3">
      <label for="address1" class="label-text">Address</label>
      <input type="text" class="text-input" name="address1" id="address1" formControlName="address1" required>
      <div *ngIf="gForm.get('address1')?.dirty && gForm.get('address1')?.invalid" class="warning">
        Address is required
      </div>
    </div>
    <div class="col-lg-4 col-12 mt-3">
      <label for="city" class="label-text">City</label>
      <input type="text" class="text-input" name="city" id="city" formControlName="city" required>
      <div *ngIf="gForm.get('city')?.dirty && gForm.get('city')?.invalid" class="warning">
        City is required
      </div>
    </div>
    <div class="col-lg-4 col-12 mt-3">
      <label for="state" class="label-text">State</label>
      <input type="text" class="state-input" name="state" id="state" formControlName="state" maxlength="2" required>
      <div *ngIf="gForm.get('state')?.dirty && gForm.get('state')?.invalid" class="warning">
        <div class="mt-1" *ngFor="let error of gForm.get('state')?.errors | objToKeys">
          {{ translateError(error) }}
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-12 mt-3">
      <label for="zipCode" class="label-text">Zip Code</label>
      <input type="text" class="text-input" name="zipCode" id="zipCode" minlength="5" maxlength="10" formControlName="zipCode" required>
      <div *ngIf="gForm.get('zipCode')?.dirty && gForm.get('zipCode')?.invalid" class="warning">
        <div *ngIf="gForm.get('zipCode')?.errors">
          <div class="mt-1" *ngFor="let error of gForm.get('zipCode')?.errors | objToKeys">
            {{translateError(error)}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12 mt-3">
      <label for="email" class="label-text">Email</label>
      <input type="text" class="text-input" name="email" id="email" formControlName="email" required>
      <div *ngIf="gForm.get('email')?.dirty && gForm.get('email')?.invalid" class="warning">
        <div *ngIf="gForm.get('email')?.errors">
          <div class="mt-1" *ngFor="let error of gForm.get('email')?.errors | objToKeys">
            {{translateError(error)}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12 mt-3 mb-3">
      <label for="phoneNumber" class="label-text">Phone Number</label>
      <input type="text" class="text-input" name="phoneNumber" id="phoneNumber" formControlName="phoneNumber" mask="(000)000-0000" placeholder="(555)555-5555" >
      <div *ngIf="gForm.get('phoneNumber')?.invalid && (gForm.get('phoneNumber')?.dirty || gForm.get('phoneNumber')?.touched)" class="warning">
        <div *ngIf="gForm.get('phoneNumber')?.errors">
          <div class="mt-1" *ngFor="let error of gForm.get('phoneNumber')?.errors | objToKeys">
            {{translateError(error)}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12 small-header-text">
      Dentist Information
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-12 mt-3">
      <label for="officeName" class="label-text">Office Name</label>
      <input type="text" class="text-input" name="officeName" id="officeName" formControlName="officeName" required>
      <div *ngIf="gForm.get('officeName')?.dirty && gForm.get('officeName')?.invalid" class="warning">
        Office Name is required
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-12 mt-3">
      <label for="officeAddress1" class="label-text">Address</label>
      <input type="text" class="text-input" name="officeAddress1" id="officeAddress1" formControlName="officeAddress1" required>
      <div *ngIf="gForm.get('officeAddress1')?.dirty && gForm.get('officeAddress1')?.invalid" class="warning">
        Address is required
      </div>
    </div>
    <div class="col-lg-4 col-12 mt-3">
      <label for="officeCity" class="label-text">City</label>
      <input type="text" class="text-input" name="officeCity" id="officeCity" formControlName="officeCity" required>
      <div *ngIf="gForm.get('officeCity')?.dirty && gForm.get('officeCity')?.invalid" class="warning">
        City is required
      </div>
    </div>
    <div class="col-lg-4 col-12 mt-3">
      <label for="officeState" class="label-text">State</label>
      <input type="text" class="state-input" name="officeState" id="officeState" formControlName="officeState" maxlength="2" required>
      <div *ngIf="gForm.get('officeState')?.dirty && gForm.get('officeState')?.invalid" class="warning">
        <div class="mt-1" *ngFor="let error of gForm.get('officeState')?.errors | objToKeys">
          {{ translateError(error) }}
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-12 mt-3">
      <label for="officeZipCode" class="label-text">Zip Code</label>
      <input type="text" class="text-input" name="officeZipCode" id="officeZipCode" minlength="5" maxlength="10" formControlName="officeZipCode" required>
      <div *ngIf="gForm.get('officeZipCode')?.dirty && gForm.get('officeZipCode')?.invalid" class="warning">
        <div *ngIf="gForm.get('officeZipCode')?.errors">
          <div class="mt-1" *ngFor="let error of gForm.get('officeZipCode')?.errors | objToKeys">
            {{translateError(error)}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12 mt-3">
      <label for="officeEmail" class="label-text">Email</label>
      <input type="text" class="text-input" name="officeEmail" id="officeEmail" formControlName="officeEmail" required>
      <div *ngIf="gForm.get('officeEmail')?.dirty && gForm.get('officeEmail')?.invalid" class="warning">
        <div *ngIf="gForm.get('officeEmail')?.errors">
          <div class="mt-1" *ngFor="let error of gForm.get('officeEmail')?.errors | objToKeys">
            {{translateError(error)}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12 mt-3">
      <label for="officePhoneNumber" class="label-text">Phone Number</label>
      <input type="text" class="text-input" name="officePhoneNumber" id="officePhoneNumber" formControlName="officePhoneNumber" mask="(000)000-0000" placeholder="(555)555-5555" >
      <div *ngIf="gForm.get('officePhoneNumber')?.invalid && (gForm.get('officePhoneNumber')?.dirty || gForm.get('officePhoneNumber')?.touched)" class="warning">
        <div *ngIf="gForm.get('officePhoneNumber')?.errors" class="warning">
          <div class="mt-1" *ngFor="let error of gForm.get('officePhoneNumber')?.errors | objToKeys">
            {{translateError(error)}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-12 mt-3">
      <label for="message" class="label-text">Describe the grievance, be as specific as possible. If applicable, specify the relevant date(s).</label>
      <input type="text" class="text-input" name="message" id="message" formControlName="message" required>
      <div *ngIf="gForm.get('message')?.dirty && gForm.get('message')?.invalid" class="warning">
        Grievance is required
      </div>
    </div>
  </div>
  <div class="col-12 mb-5">
    <div class="row">
      <div class="col-md-4">
            <span class="btn-container center" style="width: 100%">
              <button class="btn btn-lg" style="width: 100%" [disabled]="!gForm.valid" (click)="sendForm()" id="grievanceButton">Submit</button>
            </span>
      </div>
      <div class="col-8">

      </div>
    </div>
  </div>
</div>
</form>
<div class="container" *ngIf="showSuccessMessage">
  <div class="row mt-5 mb-5">
    <div class="col-12 mt-5 mb-5 center">
      <div class="center">
        <img src="assets/images/ic_yellowHappyTooth.svg" alt="yellow tooth">
      </div>
      <div class="center">
        <h3 class="title strong">You're All Set</h3>
        <p>Your grievance has been filed. Sit tight while your information is processed.</p>
        <a href="/" class="btn btn-lg">Continue</a>
      </div>
    </div>
  </div>
</div>
